import { Component, OnInit, Output, EventEmitter, Input, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Range } from '@app/shared/common/dob/dob.range';
import * as moment from 'moment';
import { detectDevices } from '@app/core/utils';

declare var $;

@Component({
  selector: 'app-dob',
  templateUrl: './dob.component.html'
})

export class DobComponent implements OnInit {
  @Input() dateString: string;
  @Output() dateChanged = new EventEmitter<Object>();
  @Output() dateCompleted = new EventEmitter();
  @ViewChild('dayContainer', { read: ElementRef }) dayContainer: ElementRef;
  @ViewChild('monthContainer', { read: ElementRef }) monthContainer: ElementRef;
  @ViewChild('yearContainer', { read: ElementRef }) yearContainer: ElementRef;

  day: string;
  month: string;
  year: string;

  dayArray: Array<string> = [];
  monthArray: Array<string> = [];
  yearArray: Array<string> = [];

  dayRange: Range;
  monthRange: Range;
  yearRange: Range;

  objectDate: Object = {};
  currentInputFocus: string;
  isDropdownValueSelected = false;
  isMobileOrTablet = false;

  constructor(private eRef: ElementRef) {
    this.dayRange = new Range(1, 31);
    this.monthRange = new Range(1, 12);
    const now = new Date();
    this.yearRange = new Range(now.getUTCFullYear() - 100, now.getUTCFullYear());
  }

  ngOnInit(): void {
    this.initDate(this.dayRange, this.monthRange, this.yearRange);
    if (this.dateString) {
      const formatDate = moment(this.dateString);
      this.day = formatDate.date() < 10 ? `0${formatDate.date().toString()}` : formatDate.date().toString();
      this.month = (formatDate.month() + 1) < 10 ? `0${(formatDate.month() + 1).toString()}` : (formatDate.month() + 1).toString();
      this.year = formatDate.year().toString();
    }

    this.isMobileOrTablet = detectDevices();
  }

  initDate(dayRange: Range, monthRange: Range, yearRange: Range): void {
    this.dayArray = [];
    this.monthArray = [];
    this.yearArray = [];

    for (let i = dayRange.min; i <= dayRange.max; i++) {
      if (i < 10) {
        this.dayArray.push(`0${i.toString()}`);
      } else {
        this.dayArray.push(i.toString());
      }
    }

    for (let i = monthRange.min; i <= monthRange.max; i++) {
      if (i < 10) {
        this.monthArray.push(`0${i.toString()}`);
      } else {
        this.monthArray.push(i.toString());
      }
    }

    for (let i = yearRange.min; i <= yearRange.max; i++) {
      this.yearArray.unshift(i.toString());
    }
  }

  checkDay(day) {
    switch (true) {
      case (Number(day) < this.dayRange.min): {
        this.day = '01';
        break;
      }
      case (Number(day) < 10 && day > 0): {
        this.day = `0${Number(day)}`;
        break;
      }
      case (Number(day) > this.dayRange.max): {
        this.day = this.dayRange.max.toString();
        break;
      }
      default:
        break;
    }
  }

  onChangeDay(day): void {
    this.checkDay(day);
    this.outputDate();
  }

  onKeyPressDay(evt): void {
    evt.preventDefault();
  }

  @HostListener('document:mouseup', ['$event'])
  mouseup(event) {
    if (!this.isMobileOrTablet) {
      this.closeDropdown(event, this.dayContainer.nativeElement);
      this.closeDropdown(event, this.monthContainer.nativeElement);
      this.closeDropdown(event, this.yearContainer.nativeElement);
    }
  }

  @HostListener('document:touchend', ['$event'])
  touchend(event) {
    if (this.isMobileOrTablet) {
      this.closeDropdown(event, this.dayContainer.nativeElement);
      this.closeDropdown(event, this.monthContainer.nativeElement);
      this.closeDropdown(event, this.yearContainer.nativeElement);
    }
  }

  closeDropdown(event, element) {
    if (!element.contains(event.target)) {
      if (element.classList.contains('open')) {
        element.classList.remove('open');
      }
    }
  }

  onClickDay(day): void {
    if (day) {
      this.day = day;
      this.outputDate();
      if ($('#inputDay').parent().hasClass('open')) {
        $('#inputDay').parent().removeClass('open');
      }
      if (!this.month) {
        $('#inputMonth').click();
      } else if (!this.year) {
        $('#inputYear').click();
      } else {
        this.dateCompleted.emit();
      }
    }
    this.isDropdownValueSelected = true;
  }

  onChangeMonth(month): void {
    this.checkDayOfMonth(Number(month));
    switch (true) {
      case (Number(month) < 10 && Number(month) > 0): {
        this.month = `0${Number(month)}`;
        break;
      }
      case (Number(month) < this.monthRange.min): {
        this.month = '01';
        break;
      }
      case (Number(month) > this.monthRange.max): {
        this.month = this.monthRange.max.toString();
        break;
      }
      default:
        break;
    }
    this.outputDate();
  }

  onKeyPressMonth(evt): void {
    evt.preventDefault();
  }

  onClickMonth(month): void {
    if (month) {
      this.month = month;
      this.checkDayOfMonth(Number(month));
      if (Number(this.day) > this.dayRange.max) {
        this.day = this.dayRange.max.toString();
      }
      this.outputDate();
      if ($('#inputMonth').parent().hasClass('open')) {
        $('#inputMonth').parent().removeClass('open');
      }
      if (!this.day) {
        $('#inputDay').click();
      } else if (!this.year) {
        $('#inputYear').click();
      } else {
        this.dateCompleted.emit();
      }
    }
    this.isDropdownValueSelected = true;
  }

  checkDayOfMonth(month: number): void {
    if (isNaN(month)) {
      return;
    }
    if (month === 1 || month === 3 || month === 5 || month === 7
      || month === 8 || month === 10 || month === 12) {
      this.dayRange.max = 31;
    } else if (month === 4 || month === 6 || month === 9 || month === 11) {
      this.dayRange.max = 30;
    } else if (month === 2) {
      if (this.year === null || this.year === undefined) {
        this.dayRange.max = 28;
      } else {
        this.isLeapYear(Number(this.year)) ? this.dayRange.max = 29 : this.dayRange.max = 28;
      }
    }
    this.initDate(this.dayRange, this.monthRange, this.yearRange);
    this.checkDay(this.day);
  }

  onChangeYear(year): void {
    this.checkDayOfMonth(Number(this.month));
    switch (true) {
      case (Number(year) < this.yearRange.min): {
        this.year = this.yearRange.min.toString();
        break;
      }
      case (Number(year) > this.yearRange.max): {
        this.year = this.yearRange.max.toString();
        break;
      }
      default:
        break;
    }
    this.outputDate();
  }

  onKeyPressYear(evt): void {
    evt.preventDefault();
  }

  onClickYear(year): void {
    if (year) {
      this.year = year;
      this.checkDayOfMonth(Number(this.month));
      this.outputDate();
      if ($('#inputYear').parent().hasClass('open')) {
        $('#inputYear').parent().removeClass('open');
      }
      if (!this.day) {
        $('#inputDay').click();
      } else if (!this.month) {
        $('#inputMonth').click();
      } else {
        this.dateCompleted.emit();
      }
    }
    this.isDropdownValueSelected = true;
  }

  isLeapYear(year: number): boolean {
    if ((year % 4 === 0 && year % 100 !== 0 && year % 400 !== 0) || (year % 100 === 0 && year % 400 === 0)) {
      return true;
    }
    return false;
  }

  outputDate() {
    if (this.day !== undefined && this.month !== undefined && this.year !== undefined) {
      this.objectDate['day'] = this.day;
      this.objectDate['month'] = this.month;
      this.objectDate['year'] = this.year;

      this.dateChanged.emit(this.objectDate);
    }
  }

  onApartChanged(day, month, year) {
    this.onChangeDay(day);
    this.onChangeMonth(month);
    this.onChangeYear(year);
  }

  handleInputDropdownClick(elementId) {
    this.currentInputFocus = elementId;
    if (elementId === 'inputYear' && !this.year) {
      this.year = moment().add(-38, 'year').get('year').toString();
      this.scrollYear(this.year);
      this.outputDate();
    }
    if (!$(`#${elementId}`).parent().hasClass('open')) {
      $(`#${elementId}`).parent().addClass('open');
    }
  }

  scrollYear = (year) => {
    const now = new Date();
    const gapYear = now.getUTCFullYear() - Number(year);
    const heighOfYearItem = 25;
    const elementDobYear = document.getElementById('scrollbars-dob-year');
    setTimeout(() => {
      elementDobYear.scrollTop = heighOfYearItem * gapYear;
    }, 0);
  }
  autoScrollToCurrentValue(gap, element) {
    const heighOfItem = 26;
    setTimeout(() => {
      element.scrollTop = gap * heighOfItem;
    }, 0);
  }

  scrollMonth = (month) => {
    const gapMonth = Number(month) - 1;
    const elementDobMonth = document.getElementById('scrollbars-dob-month');
    this.autoScrollToCurrentValue(gapMonth, elementDobMonth);
  }

  scrollDay = (day) => {
    const gapDay = Number(day) - 1;
    const elementDobDay = document.getElementById('scrollbars-dob-day');
    this.autoScrollToCurrentValue(gapDay, elementDobDay);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/dob/dob.component.ts